import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { DrawerBody, DrawerContent, DrawerOverlay } from './styles';
import { isElectronApp } from '../../helpers/common';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  placement?: 'left' | 'right' | 'top' | 'bottom';
  width?: string;
  children: React.ReactNode;
}

const CustomDrawer: React.FC<DrawerProps> = ({ open, onClose, placement = 'right', width = '350px', children }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [open, onClose]);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <>
      <DrawerOverlay role='button' open={open} onClick={onClose} />
      <DrawerContent open={open} placement={placement} width={width} className={open ? 'file-select-drawer' : ''}>
        <DrawerBody isDesktopApp={isElectronApp()}>{children}</DrawerBody>
      </DrawerContent>
    </>,
    document.body
  );
};

export default CustomDrawer;
